import React, { useEffect, useMemo } from 'react';

export interface FocusBackWrapperProps {
  readonly skipFocusBack?: boolean;
}

export const FocusBackWrapper : React.FC<FocusBackWrapperProps> = ({
  skipFocusBack,
  children,
}) => {
  const focusBackElement: any = useMemo(() => document.activeElement, []);
  useEffect(() => () => {
    if (focusBackElement?.focus && !skipFocusBack) focusBackElement.focus();
  }, []);

  return (
    <>
      {children}
    </>
  );
};
